import { fireTrackAnalytics } from '@atlassian/analytics-bridge';
import { type Cohort, type ExperimentVariant } from './types';
import { type AnalyticsEvent } from '@atlaskit/analytics-next';

const EXPERIMENT_NAMES: Record<ExperimentVariant, string> = {
	aa: 'project_pages_embedded_confluence_experiment_aa',
	ab: 'project_pages_embedded_confluence_experiment',
};

type FireExposureEvent = {
	event: AnalyticsEvent;
	experimentType: ExperimentVariant;
	cohort: Cohort;
};

export function fireExposure({ event, experimentType, cohort }: FireExposureEvent) {
	const experiment = EXPERIMENT_NAMES[experimentType];

	fireTrackAnalytics(event, 'exposed experiment', {
		action: 'viewed',
		cohort,
		experiment,
	});
}
